/* One card per mantel model; each finish retains its native product URL. */
(function () {
  'use strict';
  if (window.__efMantelFamilyCards) return;
  window.__efMantelFamilyCards = true;

  var rootSelector = '[data-efmc-collection]';
  var scheduled = false;

  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function updateReview(card, option) {
    var review = card.querySelector('[data-efmc-review]');
    if (!review) return;
    var count = Number(option.dataset.reviewCount);
    var average = Number(option.dataset.reviewAverage);
    var valid = Number.isInteger(count) && count > 0 && Number.isFinite(average) && average >= 1 && average <= 5;
    review.hidden = !valid;
    if (!valid) { review.removeAttribute('aria-label'); return; }
    var display = average.toFixed(1);
    review.setAttribute('aria-label', display + ' out of 5 stars, ' + count + (count === 1 ? ' review' : ' reviews'));
    review.querySelector('[data-efmc-review-stars]').style.setProperty('--pct', (average * 20) + '%');
    setText(review.querySelector('[data-efmc-review-average]'), display);
    setText(review.querySelector('[data-efmc-review-count]'), '(' + count + ')');
  }

  function updateSchema(root) {
    var script = root.querySelector('script[data-efmc-schema]');
    var grid = root.querySelector('.efxc-grid');
    if (!script || !grid) return;
    var items = [];
    Array.prototype.forEach.call(grid.children, function (card) {
      if (!card.matches('.efx-card') || card.hidden) return;
      var link = card.matches('a[href]') ? card : card.querySelector('[data-efmc-link], a[href]');
      var title = card.querySelector('.efx-card__title');
      if (!link || !title) return;
      var name = title.textContent.trim();
      if (!name) return;
      items.push({ '@type': 'ListItem', position: items.length + 1, name: name, url: link.href });
    });
    var schema = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      numberOfItems: items.length,
      itemListElement: items
    }).replace(/</g, '\\u003c');
    setText(script, schema);
  }

  function updateRoot(root) {
    root.querySelectorAll('[data-efms-card]').forEach(function (card) {
      var select = card.querySelector('[data-efms-select]');
      var current = card.querySelector('[data-efms-option][aria-current="true"]');
      if (select && current) {
        select.value = current.getAttribute('href');
        card.querySelector('.efms-order-select').hidden = false;
        card.setAttribute('data-efms-select-ready', '');
      }
    });
    var marker = root.querySelector('[data-efmc-count]');
    if (marker) {
      var rawCount = marker.getAttribute('data-efmc-count');
      var rawPages = marker.getAttribute('data-efmc-total-pages');
      var totalPages = Number(rawPages);
      if (/^\d+$/.test(rawCount || '') && /^\d+$/.test(rawPages || '') && totalPages <= 1) {
        var count = Number(rawCount);
        var label = count + (count === 1 ? ' mantel style' : ' mantel styles');
        root.querySelectorAll('[data-efxc-swap="count"], [data-efxc-swap="applycount"]').forEach(function (element) {
          setText(element, label);
        });
      }
    }
    updateSchema(root);
  }

  function refresh() {
    scheduled = false;
    document.querySelectorAll(rootSelector).forEach(updateRoot);
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var option = target && target.closest('a[data-efmc-option]');
    if (!option || option.hasAttribute('download') || option.target === '_blank') return;
    var card = option.closest('[data-efmc-card]');
    var root = option.closest(rootSelector);
    if (!card || !root) return;
    var link = card.querySelector('[data-efmc-link]');
    var image = card.querySelector('img[data-efmc-image]');
    var finish = option.getAttribute('data-finish');
    var src = option.getAttribute('data-image');
    var price = option.getAttribute('data-price');
    if (!link || !image || !finish || !src || !option.getAttribute('href')) return;

    event.preventDefault();
    card.querySelectorAll('[data-efmc-link]').forEach(function (mainLink) {
      mainLink.href = option.href;
    });
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    var title = card.querySelector('.efx-card__title');
    image.alt = (title ? title.textContent.trim() : 'Concrete mantel') + ' in ' + finish;
    setText(card.querySelector('[data-efmc-finish]'), finish);
    if (price !== null) setText(card.querySelector('[data-efmc-price]'), price);
    updateReview(card, option);
    card.setAttribute('data-efmc-selected-price-cents', option.getAttribute('data-price-cents') || '');
    card.setAttribute('data-efmc-selected-available', option.getAttribute('data-available') || '');
    card.querySelectorAll('[data-efmc-option]').forEach(function (other) {
      if (other === option) other.setAttribute('aria-current', 'true');
      else other.removeAttribute('aria-current');
    });
    updateSchema(root);
  });

  function selectOrderOption(option) {
    var card = option.closest('[data-efms-card]');
    var root = option.closest(rootSelector);
    if (!card || !root) return;
    card.querySelectorAll('[data-efmc-link]').forEach(function (link) {
      link.href = option.href;
      if (link.hasAttribute('aria-label')) link.setAttribute('aria-label', 'Design Specialties Steel Mantels — ' + option.dataset.label);
    });
    var image = card.querySelector('[data-efmc-image]');
    image.src = option.dataset.image;
    image.alt = 'Design Specialties steel mantel — ' + option.dataset.label;
    setText(card.querySelector('[data-efms-status]'), option.dataset.status);
    setText(card.querySelector('[data-efms-shipping]'), option.dataset.shipping);
    card.querySelectorAll('[data-efms-palette]').forEach(function (palette) {
      palette.hidden = palette.dataset.efmsPalette !== option.dataset.palette;
    });
    setText(card.querySelector('[data-efms-description]'), option.dataset.description);
    setText(card.querySelector('[data-efmc-price]'), option.dataset.price);
    setText(card.querySelector('[data-efms-cta]'), option.dataset.cta);
    updateReview(card, option);
    card.setAttribute('data-efmc-selected-price-cents', option.dataset.priceCents);
    card.querySelectorAll('[data-efms-option]').forEach(function (other) {
      if (other === option) other.setAttribute('aria-current', 'true');
      else other.removeAttribute('aria-current');
    });
    var select = card.querySelector('[data-efms-select]');
    if (select) select.value = option.getAttribute('href');
    updateSchema(root);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var option = target && target.closest('a[data-efms-option]');
    if (!option || option.target === '_blank' || option.hasAttribute('download')) return;
    if (!option.closest('[data-efms-card]') || !option.closest(rootSelector)) return;
    event.preventDefault();
    selectOrderOption(option);
  });

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!(select instanceof Element) || !select.matches('[data-efms-select]')) return;
    var card = select.closest('[data-efms-card]');
    if (!card) return;
    var option = Array.prototype.find.call(card.querySelectorAll('[data-efms-option]'), function (item) {
      return item.getAttribute('href') === select.value;
    });
    if (option) selectOrderOption(option);
  });

  function start() {
    refresh();
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        var target = mutation.target;
        if (target.nodeType === 1 && target.closest(rootSelector)) return true;
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches(rootSelector) || node.querySelector(rootSelector));
        });
      });
      if (relevant) scheduleRefresh();
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-efmc-count'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
}());
